import type { users as en } from '@/i18n/locales/en/users';
import type { Translation } from '@/i18n/types';

export const users: Translation<typeof en> = {
  page: {
    title: 'Utenti',
    noScope: 'Non hai alcun ambito amministrativo, quindi non c’è un elenco membri da mostrare.',
    departmentListsTitle: 'Elenchi membri per reparto',
    leadCompany: 'Membri di {{company}}.',
    membersOf: 'Membri di {{company}}',
    companyMembersCardTitle: 'Membri',
    addPerson: 'Aggiungi persona',
    empty: 'Nessun membro.',
    name: 'Nome',
    email: 'E-mail',
    login: 'Accesso',
    source: 'Origine',
    yes: 'sì',
    no: 'no',
    invitePerson: 'Invita',
    importCsv: 'Importa CSV',
    searchPlaceholder: 'Cerca per nome o e-mail…',
    filterDepartment: 'Reparto',
    allDepartments: 'Tutti i reparti',
    filterLocation: 'Sede',
    allLocations: 'Tutte le sedi',
    filterStatus: 'Stato',
    allStatuses: 'Tutti gli stati',
    employee: 'Dipendente',
    department: 'Reparto',
    location: 'Sede',
    lastSync: 'Ultima sincronizzazione',
    consent: 'Consenso',
    wearable: 'Wearable',
    pilot: 'Pilota',
    account: 'Account',
    actions: 'Azioni',
    accountActive: 'Attivo',
    accountDeactivated: 'Disattivato',
    noLocation: 'Nessuna sede',
    noDepartment: 'Nessun reparto',
    activation: {
      label: 'Attivazione',
      invited: 'Invitato',
      activated: 'Attivato',
      active: 'Attivo',
      inactive: 'Inattivo',
      deactivated: 'Disattivato',
    },
    consentStatus: {
      pending: 'In attesa',
      confirmed: 'Confermato',
      declined: 'Ritirato',
      none: 'Nessuno',
    },
  },
  detail: {
    thisPerson: 'questa persona',
    edit: 'Modifica',
    name: 'Nome',
    email: 'E-mail',
    nickname: 'Soprannome',
    preferredLanguage: 'Lingua preferita',
    region: 'Regione',
    login: 'Accesso',
    yes: 'sì',
    no: 'no',
    gender: 'Genere',
    birthdate: 'Data di nascita',
    height: 'Altezza',
    weight: 'Peso',
    privateNote:
      'Genere, data di nascita, altezza e peso sono privati per questa persona e non fanno parte di ciò che gli altri vedono di lei.',
    actionsCardTitle: 'Azioni',
    statsCardTitle: 'Statistiche',
  },
  edit: {
    title: 'Modifica dati personali',
    lead: 'Nome ed e-mail provengono dall’account di accesso e non possono essere modificati qui.',
    cancel: 'Annulla',
    save: 'Salva',
  },
  addPerson: {
    created: 'Persona creata.',
    inviteSent: 'Un’e-mail di invito è in arrivo.',
    alreadyHasLogin: 'Hanno già un accesso.',
    noLoginYet: 'Non hanno ancora un accesso — puoi invitarli più tardi dall’elenco membri.',
    done: 'Fatto',
    name: 'Nome',
    email: 'E-mail',
    emailHint: 'Facoltativo — se presente, la persona viene invitata ad accedere.',
    nickname: 'Soprannome',
    region: 'Regione',
    conflict:
      'Esiste già una persona con questo indirizzo e-mail{{reason}}. Aggiungi quella persona esistente all’ambito invece di crearne una duplicata.',
    cancel: 'Annulla',
    create: 'Crea persona',
    companyTitle: 'Aggiungi una persona all’azienda',
    departmentTitle: 'Aggiungi una persona al reparto',
    newPersonCardTitle: 'Nuova persona',
    existingCardTitle: 'Membro esistente dell’azienda',
    existingPersonCardTitle: 'Persona esistente',
    member: 'Membro',
    person: 'Persona',
    choose: 'Scegli…',
    addToDepartment: 'Aggiungi al reparto',
    addToCompany: 'Aggiungi all’azienda',
    searchPeople: 'Cerca persone',
    searchPlaceholder: 'Nome o e-mail',
    noEligible: 'Nessuna persona corrispondente trovata.',
    editionMismatch:
      'L’edizione di questa persona è diversa da quella dell’azienda. Cambia prima l’edizione della persona o dell’azienda, quindi riprova.',
  },
  actions: {
    invite: 'Invita',
    inviteAgain: 'Invita di nuovo',
    changeEmail: 'Cambia e-mail',
    newEmail: 'Nuovo indirizzo e-mail',
    save: 'Salva',
    cancel: 'Annulla',
    remove: 'Rimuovi',
    unlink: 'Scollega',
    unlinkFromPilot: 'Scollega dal pilota',
    erase: 'Cancella',
    changeLocation: 'Cambia sede',
    changeDepartment: 'Cambia reparto',
    deactivate: 'Disattiva',
    activate: 'Attiva',
  },
  invite: {
    title: 'Invita una persona',
    name: 'Nome',
    email: 'Indirizzo e-mail',
    role: 'Ruolo',
    roleMember: 'Dipendente',
    roleAdmin: 'Amministratore aziendale',
    submit: 'Invita',
    cancel: 'Annulla',
  },
  import: {
    title: 'Importa CSV',
    instructions: 'Incolla o carica un CSV con le colonne: nome, e-mail, reparto, sede.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Oppure carica un file',
    submit: 'Importa',
    cancel: 'Annulla',
    done: 'Fatto',
    summary: '{{imported}} importati, {{failed}} falliti.',
    rowLabel: 'Riga {{row}}',
    rowSuccess: 'Importato',
    rowFailed: 'Fallito',
  },
};
